<template>
  <v-row>
    <v-col cols="12" class="text-right">
      <px-indicadores-compras-filtro />
      <px-select-date-range :initial-date-selection="dateSelection"
                            @change="onChangeDate"/>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { SET_DATE_ACT } from '@/store/dashboard/actions.type';
import IndicadoresComprasFiltro from '@/modules/indicadores-compras/IndicadoresComprasFiltro.vue';

export default {
  computed: {
    ...mapGetters('indicadoresCompras', ['dateSelection']),
  },
  methods: {
    ...mapActions('indicadoresCompras', {
      setDateSelection: SET_DATE_ACT,
    }),
    onChangeDate(dateState) {
      this.setDateSelection(dateState);
    },
  },
  components: {
    pxIndicadoresComprasFiltro: IndicadoresComprasFiltro,
  },
};
</script>
